export const INDEXED_DB_NAME = "imageUploaderDB";
export const INDEXED_DB_VERSION = 2;
export const OST_CREATION_IMAGE_STORE = "ost-images";
/** Retained only for version-2 compatibility; its records are cleared on open. */
export const LEGACY_UPLOAD_PROGRESS_STORE = "upload-progress";

export const OST_UPLOAD_STORES = {
  delivery: "upload-delivery",
  awaitingEvent: "upload-awaiting-events",
  batch: "upload-batches",
  expired: "upload-expired",
  reservation: "upload-name-reservations",
  usageDirty: "upload-usage-dirty",
  lease: "upload-leases",
  imageCache: "image-cache",
} as const;

export const PERSISTENT_OST_UPLOAD_STORES = [
  OST_UPLOAD_STORES.delivery,
  OST_UPLOAD_STORES.awaitingEvent,
  OST_UPLOAD_STORES.batch,
  OST_UPLOAD_STORES.expired,
  OST_UPLOAD_STORES.reservation,
  OST_UPLOAD_STORES.usageDirty,
] as const;
